export const state = {
  typePiece: undefined,
  typePieces: [],
  communes: [],
  sousTypePiece: undefined,
  sousTypePieces: []
}